import Home from "./components/home/Home";
import Cases from "./components/cases/Cases";
import Blog from "./components/blog/Blog";
import Detailsblog from "./components/blog/Detailsblog";
import Contato from "./components/contato/Contato";
// import Clipping from "./components/clipping/Clipping";
// import Detailsclipping from "./components/clipping/Detailsclipping";
import Jobs from "./components/jobs/Jobs";
import Detailsjob from "./components/jobs/Detailsjob";
import Servicos from "./components/servicos/Servicos";
import Produtos from "./components/produtos/Produtos";
import Drone from "./components/drone/Drone";
import Storm from "./components/storm/Storm";
import politicaDePrivacidade from "./components/politicaDePrivacidade/politicaDePrivacidade";
import SuccessMsg from "./components/jobs/SuccessMsg";
import SuccessContact from "./components/contato/SuccessContact";

export const routes = messages => [
  { path: "/", name: "home", component: Home, titulo: "home", menu: false },
  {
    path: "/sobre",
    name: "sobre",
    component: Storm,
    titulo: messages.menu["sobre"],
    menu: true
  },
  {
    path: "/politica-de-privacidade",
    name: "politica-de-privacidade",
    component: politicaDePrivacidade,
    titulo: messages.menu["politica-de-privacidade"],
    menu: false
  },
  {
    path: "/servicos",
    name: "servicos",
    component: Servicos,
    titulo: messages.menu["servicos"],
    menu: true
  },
  {
    path: "/produtos",
    name: "produtos",
    component: Produtos,
    titulo: messages.menu["produtos"],
    menu: true
  },
  {
    path: "/produtos/:slug",
    name: "produto",
    component: Home,
    titulo: messages.menu["produtos"],
    menu: false
  },
  /*{ path: '/na-midia/', name: 'clipping', component: Clipping, titulo: 'Na mídia', menu: true},
	{ path: '/na-midia/:slug', name: 'clipping', component: Detailsclipping, titulo: 'Na mídia', menu: false},*/
  {
    path: "/drones",
    name: "drones",
    component: Drone,
    titulo: messages.menu["drones"],
    menu: true
  },
  {
    path: "/cases",
    name: "cases",
    component: Cases,
    titulo: messages.menu["cases"],
    menu: true
  },
  {
    path: "/blog",
    name: "blog",
    component: Blog,
    titulo: messages.menu["blog"],
    menu: true
  },
  {
    path: "/blog/:slug",
    name: "detailsblog",
    component: Detailsblog,
    titulo: messages.menu["blog"],
    menu: false
  },
  {
    path: "/trabalhe-conosco",
    name: "jobs",
    component: Jobs,
    titulo: messages.menu["trabalhe-conosco"],
    menu: true
  },
  {
    path: "/trabalhe-conosco/:slug",
    name: "Trabalheconosco",
    component: Detailsjob,
    titulo: messages.menu["trabalhe-conosco"],
    menu: false
  },
  {
    path: "/contato",
    name: "contato",
    component: Contato,
    titulo: messages.menu["contato"],
    menu: true
  },
  {
    path: "/contato/sucesso",
    name: "contatosucesso",
    component: SuccessContact,
    titulo: messages.menu["contato"],
    menu: false
  },
  {
    path: "/sucesso",
    name: "jobSuccess",
    component: SuccessMsg,
    titulo: messages.menu["contato"],
    menu: false
  }
];



// WEBPACK FOOTER //
// ./src/routes.js